export default __webpack_public_path__ + "static/media/photo.cb35a577.png";